import React from "react";

import ContentResumo from "./ContentResumo";

const Resumo = () => {
  return (
    <>
      <ContentResumo />
    </>
  );
};

export default Resumo;
